import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-gray-50" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-46">
          <h2 className="text-emerald-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-47">
            Get In Touch
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-48">
            Request Your Free Quote
          </h3>
          <p className="text-lg text-gray-600" data-id="element-49">
            Ready for a better lawn? Give us a{' '}
            <span className="text-emerald-600 font-semibold" data-id="element-50">call</span> or send
            a <span className="text-emerald-600 font-semibold" data-id="element-51">text</span>. We
            typically respond within 24 hours.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-52">
          {/* Contact Information */}
          <div className="bg-emerald-900 text-white p-12 flex flex-col justify-between relative overflow-hidden" data-id="element-53">
            {/* Decorative circles */}
            <div className="absolute top-0 right-0 -mt-16 -mr-16 w-64 h-64 rounded-full bg-emerald-800/50 blur-2xl" data-id="element-54"></div>
            <div className="absolute bottom-0 left-0 -mb-16 -ml-16 w-64 h-64 rounded-full bg-emerald-800/50 blur-2xl" data-id="element-55"></div>

            <div className="relative z-10" data-id="element-56">
              <h4 className="text-2xl font-bold mb-8" data-id="element-57">Contact Information</h4>

              <div className="space-y-8" data-id="element-58">
                <div className="flex items-start gap-4" data-id="element-59">
                  <Phone className="h-6 w-6 text-lime-400 flex-shrink-0 mt-1" data-id="element-60" />
                  <div data-id="element-61">
                    <p className="font-medium text-emerald-100 mb-1" data-id="element-62">Phone</p>
                    <a href="tel:+13852518659" className="text-lg font-semibold hover:text-lime-400 transition-colors" data-id="element-63">
                      (385) 251-8659
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-64">
                  <Mail className="h-6 w-6 text-lime-400 flex-shrink-0 mt-1" data-id="element-65" />
                  <div data-id="element-66">
                    <p className="font-medium text-emerald-100 mb-1" data-id="element-67">Email</p>
                    <a href="mailto:greenvalley7500@outlook.com" className="text-lg font-semibold hover:text-lime-400 transition-colors" data-id="element-68">
                      greenvalley7500@outlook.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-69">
                  <MapPin className="h-6 w-6 text-lime-400 flex-shrink-0 mt-1" data-id="element-70" />
                  <div data-id="element-71">
                    <p className="font-medium text-emerald-100 mb-1" data-id="element-72">
                      Service Area
                    </p>
                    <p className="text-lg font-semibold" data-id="element-73">
                      West Jordan & Surrounding Counties within 30 miles
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-74">
                  <Clock className="h-6 w-6 text-lime-400 flex-shrink-0 mt-1" data-id="element-75" />
                  <div data-id="element-76">
                    <p className="font-medium text-emerald-100 mb-1" data-id="element-77">
                      Business Hours
                    </p>
                    <p className="text-lg font-semibold" data-id="element-78">
                      Mon - Sun: 7am - 6pm
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}